import "./SuccessVerification.css";
import React from "react";
import { Fragment } from "react";
import Auth from "../../components/auth/auth";
import { Link, useNavigate } from "react-router-dom";
import { useState } from "react";
import { useEffect } from "react";
import successCoverImg from "../../assets/login/success.svg";
import BrandLogoTop from "../../components/BrandLogo/BrandLogoTop";

const SuccessVerification = () => {
  const navigate = useNavigate();

  //Check that is it mobile screen
  const [isMobile, setIsMobile] = useState(false);
  const setWindowDimensions = () => {
    if (window.innerWidth < 575) {
      setIsMobile(true);
    } else {
      setIsMobile(false);
    }
  };

  useEffect(() => {
    window.addEventListener("resize", setWindowDimensions);
    setWindowDimensions();
    return () => {
      window.removeEventListener("resize", setWindowDimensions);
    };
  }, []);

  return (
    <div className="success-page-container">
      <div className="success-page-content">
        <div className="success-page-left">
          {/* <div className="page-title">Successful Verification</div> */}
          <img src={successCoverImg} alt="img" className="page-cover-image" />
        </div>
        <div className="success-page-right">
          <BrandLogoTop />
          <h2 className="form-heading">Successful Verification</h2>
          <div className="mt-3">
            <p className="verification-completed">Verification Completed</p>
          </div>
          <div class="success-animation">
            <svg
              class="checkmark2"
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 52 52"
            >
              <circle
                class="checkmark__circle"
                cx="26"
                cy="26"
                r="25"
                fill="none"
              />
              <path
                class="checkmark__check"
                fill="none"
                d="M14.1 27.2l7.1 7.2 16.7-16.8"
              />
            </svg>
          </div>
          <div class="text-center">
            <Link to="/login" class="navigation-btn-from-success-to-login">
              Go To Login Page
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SuccessVerification;
